import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface TriggerPreviewState {
  gateId: string | null;
  time: number;
  end: number;
}

const initialState: TriggerPreviewState = { gateId: null, time: 0, end: 0 };

const triggerPreviewSlice = createSlice({
  name: 'triggerPreview',
  initialState,
  reducers: {
    startPreview: (state, action: PayloadAction<{ gateId: string; time: number; end: number }>) => {
      state.gateId = action.payload.gateId;
      state.time = action.payload.time;
      state.end = action.payload.end;
    },
    tickPreview: (state, action: PayloadAction<number>) => {
      state.time = action.payload;
    },
    clearPreview: (state) => {
      state.gateId = null;
      state.time = 0;
      state.end = 0;
    },
  },
});

export const { startPreview, tickPreview, clearPreview } = triggerPreviewSlice.actions;
export default triggerPreviewSlice.reducer;
